export type ColorType = "danger" | "important" | "neutral" | "good" | "best";
export type NewsEstimate = {
	content: string;
	color: ColorType;
} | null;

export function getNewsEstimate(
	sentiment: number | undefined,
	significancy: number | undefined,
): NewsEstimate | null {
	if (sentiment == null || significancy == null) return null;

	let content = "";

	if (sentiment > 3) {
		content += "+";
	} else if (sentiment < 3) {
		content += "-";
	}

	if (significancy > 6) {
		content += content;
	}

	const colorMap: Record<string, ColorType> = {
		"--": "danger",
		"-": "important",
		"+": "best",
		"++": "best",
	};

	const color = colorMap[content] || "neutral";

	return { content, color };
}
